import { css } from "@emotion/react";
import { fontSize } from "../../../../../../styles/fonts";

export const disabledFormStyles = css`
  cursor: not-allowed;

  input[disabled],
  select[disabled] {
    background: none;
    color: var(--disabled-color, black);

    cursor: not-allowed;

    ${fontSize.x2};
  }
`;
